import {
  REPORTING_UNITS_CLEAR,
  REPORTING_UNITS_CLEAR_FILTER_VALUE,
  REPORTING_UNITS_FETCH,
  REPORTING_UNITS_FETCH_BY_BRAND,
  REPORTING_UNITS_FETCH_RESTAURANTS,
  REPORTING_UNITS_GROUP_RESTAURANTS_FETCH,
  REPORTING_UNITS_GROUPS_FETCH,
  REPORTING_UNITS_GROUPS_COUNTRIES_FETCH,
  REPORTING_UNITS_SET_FILTER_VALUE,
} from '../action-types/reporting-unit-types';

const initialState = {
  reportingUnits: [],
  reportingUnitsRestaurants: [],
  reportingUnitsCountries: [],
  loading: false,
  rejected: false,
  filterValue: {},
};

export default function (state: any = initialState, action) {
  switch (action.type) {
    case REPORTING_UNITS_FETCH.REQUEST:
    case REPORTING_UNITS_GROUPS_FETCH.REQUEST:
    case REPORTING_UNITS_FETCH_BY_BRAND.REQUEST:
    case REPORTING_UNITS_GROUPS_COUNTRIES_FETCH.REQUEST:
      return {
        ...state,
        loading: true,
        rejected: false,
      };
    case REPORTING_UNITS_FETCH.SUCCESS:
      return {
        ...state,
        reportingUnits: [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case REPORTING_UNITS_GROUPS_COUNTRIES_FETCH.SUCCESS: {
      const { data, meta } = action.payload;
      const brandFGs = state.franchiseGroupsById?.[meta.brand] || {};

      return {
        ...state,
        franchiseGroupsById: {
          ...state.franchiseGroupsById,
          [meta.brand]: {
            ...brandFGs,
            ...(meta.isCompanyRU && { '-1': {} }), // For company restaurants we are not retrieving FGs so resetting FG id just after fetching countries.
          },
        },
        reportingUnitsCountries: data?.map(
          ({ region_, base_name, ...rest }) => ({
            ...rest,
            name: `${region_} - ${base_name}`,
          }),
        ),
        loading: false,
        rejected: false,
      };
    }
    case REPORTING_UNITS_FETCH_RESTAURANTS.SUCCESS:
      return {
        ...state,
        reportingUnitsRestaurants: [...action.payload.data],
        loading: false,
        rejected: false,
      };
    case REPORTING_UNITS_GROUP_RESTAURANTS_FETCH.REJECTED:
    case REPORTING_UNITS_FETCH.REJECTED:
    case REPORTING_UNITS_FETCH_BY_BRAND.REJECTED:
    case REPORTING_UNITS_GROUPS_COUNTRIES_FETCH.REJECTED:
      return {
        ...state,
        loading: false,
        rejected: true,
      };
    case REPORTING_UNITS_CLEAR:
      return {
        ...state,
        reportingUnits: [],
        reportingUnitsCountries: [],
        loading: false,
        rejected: false,
      };
    case REPORTING_UNITS_SET_FILTER_VALUE:
      return {
        ...state,
        filterValue: action.payload,
      };
    case REPORTING_UNITS_CLEAR_FILTER_VALUE:
      return {
        ...state,
        filterValue: {},
      };

    case REPORTING_UNITS_FETCH_BY_BRAND.SUCCESS: {
      const { data, meta } = action.payload;
      return {
        ...state,
        reportingUnitsByBrand: {
          ...state.reportingUnitsByBrand,
          [meta.brand]: data.reduce(
            (acc, { id, ...item }) => ({
              ...acc,
              [id]: item,
            }),
            {},
          ),
        },
        loading: false,
        rejected: false,
      };
    }

    case REPORTING_UNITS_GROUPS_FETCH.SUCCESS: {
      const { data, meta } = action.payload;
      const brandRUs = state.reportingUnitsByBrand?.[meta.brand] || {};
      const brandFGs = state.franchiseGroupsById?.[meta.brand] || {};
      const groupsObj = data.reduce(
        (acc, group) => ({
          ...acc,
          [group.id]: group,
        }),
        {},
      );
      return {
        ...state,
        reportingUnitsByBrand: {
          ...state.reportingUnitsByBrand,
          [meta.brand]: {
            ...brandRUs,
            [meta.reportUnitId]: {
              ...brandRUs?.[meta.reportUnitId],
              groups: data.map(group => group.id),
            },
          },
        },
        franchiseGroupsById: {
          ...state.franchiseGroupsById,
          [meta.brand]: {
            ...brandFGs,
            ...groupsObj,
          },
        },
        loading: false,
        rejected: false,
      };
    }

    case REPORTING_UNITS_GROUP_RESTAURANTS_FETCH.REQUEST:
      return {
        ...state,
        loading: false,
        rejected: false,
      };
    case REPORTING_UNITS_GROUP_RESTAURANTS_FETCH.SUCCESS: {
      const {
        data: { restaurants, pagination },
        meta,
      } = action.payload;
      const brandFGs = state.franchiseGroupsById?.[meta.brand] || {};
      const groupRestaurants = [
        ...(brandFGs[meta.groupId]?.restaurants || []),
        ...restaurants,
      ];
      const { total, limit, page } = pagination || {};
      return {
        ...state,
        franchiseGroupsById: {
          ...state.franchiseGroupsById,
          [meta.brand]: {
            ...brandFGs,
            [meta.groupId]: {
              ...brandFGs[meta.groupId],
              restaurants: groupRestaurants,
              restaurantsPagination: {
                total,
                pageSize: limit,
                lastPage: page,
                loadedCount: groupRestaurants.length,
              },
            },
          },
        },
        loading: false,
        rejected: false,
      };
    }
    default:
      return { ...state };
  }
}
